import moment from 'moment';
import get from 'lodash/get';
import produce from 'immer';
import { createAction } from '@reduxjs/toolkit';
import {
  FETCH_APPOINTMENT_TYPES,
  FETCH_SYMPTOM_TYPES,
  UPLOAD_LETTERS,
  APPOINTMENT_LOADER,
  CREATE_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_ERROR,
  ERROR_RESET,
  FETCH_APPOINTMENT_ARTICLES,
  UPLOAD_MEDICAL_RECORDS,
  CREATE_MEDICAL_RECORDS_ERROR,
  CREATE_MEDICAL_RECORDS_SUCCESS,
  FORM_RESET,
  GET_FILE_URL,
  FETCH_APPOINTMENT_ORDERS,
  FETCH_MEDICAL_DOCUMENTS,
  FETCH_APPOINTMENT_REPORTS,
  GET_FILE_URL_ERROR,
  FETCH_APPOINTMENT_FAX_LOGS_SUCCESS,
} from './Constants';
import { getImageType } from '../helpers/helperFunctions';

export const fetchReportsByAppointmentId = createAction('Appointment/fetchReportsByAppointmentId');
export const fetchReportsByAppointmentIdSuccess = createAction('Appointment/fetchReportsByAppointmentIdSuccess');

const initialState = {
  appointmentTypes: [],
  symptomTypes: [],
  loaded: true,
  letter: [],
  success: false,
  error: null,
  articles: [],
  medicalRecords: [],
  MRSuccess: false,
  MRError: null,
  pdfLink: null,
  PASuccess: false,
  reportUrlKey: null,
  fileUrl: null,
  orders: [],
  medicalDocuments: [],
  encounterReports: [],
  reportUrlError: false,
  faxLogs: [],
  reports: {
    patientReports: [],
    providerReports: [],
  },
};

// TODO: Need proper error messages from the backend

const uploadLetters = (state, action) => {
  const arr = action.payload.data.map(imageStr => ({
    isNew: true,
    link: imageStr,
    type: getImageType(imageStr.split('.')[1]),
    timestamp: moment().format('MM/DD/YYYY hh:mm'),
  }));
  return { ...state, letter: arr, loaded: true };
};

const createAppointmentError = (state, action) => {
  return {
    ...state,
    loaded: true,
    error: 'Something Went Wrong. Please contact PhyPal support.',
    success: false,
  };
};

const downloadFile = (state, action) => {
  const link = document.createElement('a');
  link.href = action.payload.data[0].accessUrl;
  link.target = '_blank';
  link.click();
  return { ...state, fileUrl: action.payload.data[0].accessUrl, loaded: true };
};

const AppointmentReducer = (state = initialState, action) => {
  const { type, payload } = action;
  if (type === FETCH_APPOINTMENT_FAX_LOGS_SUCCESS) {
    return produce(state, draft => {
      draft.faxLogs = get(payload.data, 'faxList', []);
    });
  }
  switch (action.type) {
    case APPOINTMENT_LOADER:
      return { ...state, loaded: false };
    case FETCH_APPOINTMENT_TYPES:
      return { ...state, appointmentTypes: action.payload.data };
    case FETCH_SYMPTOM_TYPES:
      return { ...state, symptomTypes: action.payload.data };
    case UPLOAD_LETTERS:
      return uploadLetters(state, action);
    case CREATE_APPOINTMENT_SUCCESS:
      return { ...state, success: true, loaded: true };
    case CREATE_APPOINTMENT_ERROR:
      return createAppointmentError(state, action);
    case ERROR_RESET:
      return { ...state, error: null, loaded: true, MRError: null };
    case FETCH_APPOINTMENT_ARTICLES:
      return { ...state, articles: action.payload.data, loaded: true };
    case UPLOAD_MEDICAL_RECORDS:
      return { ...state, medicalRecords: action.payload.data, loaded: true };
    case CREATE_MEDICAL_RECORDS_ERROR:
      return {
        ...state,
        loaded: true,
        MRError: 'Something Went Wrong. Please contact Snapcare support.',
        MRSuccess: false,
      };
    case CREATE_MEDICAL_RECORDS_SUCCESS:
      return {
        ...state,
        loaded: true,
        MRSuccess: true,
        medicalDocuments: [...state.medicalDocuments, action.payload.data],
      };
    case GET_FILE_URL:
      return downloadFile(state, action);
    case GET_FILE_URL_ERROR:
      return { ...state, loaded: true };
    case FORM_RESET:
      return {
        ...state,
        success: false,
        error: null,
        loaded: true,
        PASuccess: false,
        MRSuccess: false,
        MRError: null,
        letter: [],
      };
    case FETCH_APPOINTMENT_ORDERS:
      return { ...state, orders: action.payload.data, loaded: true };
    case FETCH_MEDICAL_DOCUMENTS:
      return { ...state, medicalDocuments: action.payload.data, loaded: true };
    case FETCH_APPOINTMENT_REPORTS:
      return { ...state, encounterReports: action.payload.data, loaded: true };
    case FETCH_APPOINTMENT_FAX_LOGS_SUCCESS:
      return { ...state, faxLogs: action.payload.data };
    case fetchReportsByAppointmentIdSuccess.type:
      return { ...state, reports: action.payload.data };
    default:
      return state;
  }
};

export default AppointmentReducer;
